(function() {
  function initMobileMenuDrawer(root) {
    if (!root || root.dataset.mobileMenuDrawerInit) return;
    root.dataset.mobileMenuDrawerInit = 'true';

    var panelButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mobile-menu-target]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mobile-menu-panel]'));
    var openButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mobile-menu-action="open-category"]'));
    var backButton = root.querySelector('[data-mobile-menu-back]');
    var homePanelId = 'home';
    var drawerHost = root.closest('hdt-drawer');

    function activatePanel(index) {
      panelButtons.forEach(function(button) {
        var isActive = button.dataset.mobileMenuTarget === String(index);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function(panel) {
        var isActive = panel.dataset.mobileMenuPanel === String(index);
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      root.classList.toggle('mobile-menu-home-active', index === homePanelId);

      if (index !== homePanelId) {
        var activePanel = root.querySelector('[data-mobile-menu-panel="' + index + '"]');
        if (activePanel) {
          activePanel.scrollTop = 0;
        }
      }
    }

    panelButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        activatePanel(button.dataset.mobileMenuTarget);
      });
    });

    openButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        activatePanel(button.dataset.mobileMenuTarget);
      });
    });

    function closeDrawerHost() {
      if (!drawerHost) return;
      if (typeof drawerHost.hide === 'function') {
        drawerHost.hide();
        return;
      }
      if (drawerHost.shadowRoot) {
        var closeBtn = drawerHost.shadowRoot.querySelector('[part="close-button"], [part="outside-close-button"]');
        if (closeBtn) {
          closeBtn.click();
          return;
        }
      }
      drawerHost.removeAttribute('open');
    }

    if (backButton) {
      backButton.addEventListener('click', function() {
        if (root.classList.contains('mobile-menu-home-active')) {
          closeDrawerHost();
        } else {
          activatePanel(homePanelId);
        }
      });
    }

    function resetToHome() {
      activatePanel(homePanelId);
    }

    if (drawerHost) {
      drawerHost.addEventListener('toggle', function() {
        if (drawerHost.hasAttribute('open')) {
          resetToHome();
        }
      });

      var observer = new MutationObserver(function() {
        if (drawerHost.hasAttribute('open')) {
          resetToHome();
        }
      });
      observer.observe(drawerHost, { attributes: true, attributeFilter: ['open', 'class'] });
    }

    activatePanel(homePanelId);
  }

  function boot() {
    document.querySelectorAll('[data-mobile-menu-drawer]').forEach(initMobileMenuDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
